import {catchUnhandledDataGridActions} from '@dms/shared';

import {openBulkOperationActionDialog, type BulkOperationActionCallback} from 'features/eag-grid';

import {CustomerReassignBulkForm} from '../pages/CustomerOverview/components/CustomerReassignBulkForm/CustomerReassignBulkForm';

export const customerBulkOperationActionCallback: BulkOperationActionCallback = (action) => {
  if (action.actionKey === 'REASSIGN') {
    return openBulkOperationActionDialog(action, <CustomerReassignBulkForm action={action} />);
  }
  catchUnhandledDataGridActions(action.actionKey);
};
